import React from 'react'
import pt from 'prop-types'
import { SortableElement } from 'react-sortable-hoc'
import { openMod } from '../../modules/mods'
import { connect } from 'react-redux'
import SortableHandle from './SortableHandle'
import Pencil from '../icon/Pencil'
import './SortableItem.scss'

const SortableItem = SortableElement(({ value, state, openMod }) => {
  return (
    <div className="sortable-item-menu">
      <div
        className="sortable-item-menu__left"
        onMouseDown={e => {
          openMod({ type: 'sortSection', ...value })
        }}
      >
        <div className="sortable-item-menu__svg">
          <Pencil />
        </div>
        {value.name}
      </div>
      <div className="sortable-item-menu__handler">
        <SortableHandle />
      </div>
    </div>
  )
})

SortableItem.propTypes = {
  value: pt.object,
  state: pt.object
}

const mapDispatchToProps = {
  openMod
}

const mapStateToProps = (state, props) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SortableItem)
